import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { LoginGuardService } from '../../api/login-guard.service';
import { LangService } from '../../core/lang.service';
import { StyleprofileService } from '../../core/styleprofile.service';
import { ImageStates } from '../element-render-image/model';
import { McqRenderer } from '../element-render-mcq/element-render-mcq-functions';
import { IContentElementMcqOption } from '../element-render-mcq/model';
import { ElementType, QuestionState } from '../models';
import { QuestionPubSub } from '../question-runner/pubsub/question-pubsub';
import { TextToSpeechService } from '../text-to-speech.service';
import { IContentElementCustomMCQ } from './model';
import { EditSelectionService } from '../edit-selection.service';


@Component({
  selector: 'element-render-custom-mcq',
  templateUrl: './element-render-custom-mcq.component.html',
  styleUrls: ['./element-render-custom-mcq.component.scss']
})
export class ElementRenderCustomMCQComponent implements OnInit {

    @Input() element:IContentElementCustomMCQ;
    @Input() isLocked:boolean;
    @Input() isShowSolution:boolean;
    @Input() questionState:QuestionState;
    @Input() questionPubSub?: QuestionPubSub;

  mcqRenderer;

  getMcqContent = (selection)=>{
    let content = selection.dynamicImage.images[ImageStates.SELECTED];
    if (!content || !content.image) {
      content = selection.dynamicImage.images[ImageStates.DEFAULT];
    }
    let url = "";
    if (content && content.image && content.image.url) {
      url = content.image.url;
    }
    return url;
  }

  constructor(
    private textToSpeech:TextToSpeechService,
    private profile: StyleprofileService,
    private lang: LangService,
    private loginGuard: LoginGuardService,
    public editSelection: EditSelectionService
  ) {
    
  }

  ElementType = ElementType;

  currentSelections:IContentElementMcqOption[] = [];
  isStarted = false;

  ngOnInit() {
    this.ensureMcqRenderer();
    this.ensureState();
  }

  ensureMcqRenderer(){
    if (!this.mcqRenderer){
      this.mcqRenderer = new McqRenderer(
        this.element,
        this.questionState,
        this.getMcqContent,
        this.isShowSolution,
        this.isLocked,
        this.textToSpeech,
        this.profile,
        this.loginGuard,
        this.lang,
        null,
      );
    }
  }

  ngOnChanges(changes:SimpleChanges) {
    this.ensureMcqRenderer();
    this.mcqRenderer.checkForChanges(changes)
  }

  isSelected(option: IContentElementMcqOption) {
    return this.mcqRenderer.isSelected(option);
  }

  getOptionGroupRole(){
    return this.element.isMultiSelect ? 'group' : 'radiogroup';
  }

  getOptionRole(){
    return this.element.isMultiSelect ? 'checkbox' : 'radio';
  }

  getOptionGroupLabel(){
    return this.lang.tra(this.element.isMultiSelect
      ? 'sr_custom_mcq_select_all_choices'
      : 'sr_custom_mcq_answer_choices');
  }

  getOptionLabel(option:any, index:number){
    const imageLabel = option.dynamicImage?.altText || '';
    const subtext = (option.subtext || []).map(text => text.text).filter(Boolean).join(' ');
    return [imageLabel, subtext].filter(Boolean).join(' ') || this.lang.tra(
      'sr_custom_mcq_option_number',
      undefined,
      { number: index + 1 }
    );
  }

  handleOptionKeydown(event:KeyboardEvent, option:IContentElementMcqOption){
    if (this.isLocked || (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }
    event.preventDefault();
    this.selectOptionManual(option);
  }

  selectOptionManual(option:IContentElementMcqOption){
    return this.mcqRenderer.selectOptionManual(option); 
  }

  selectOption(option:IContentElementMcqOption) {
    return this.mcqRenderer.selectOption(option);
  }

  ensureState(){
    return this.mcqRenderer.ensureState();
  }

  handleNewState(){
     this.mcqRenderer.handleNewState();
  }

  getIsMaxMsgShowing() {
    return this.mcqRenderer.isMaxAnswerMsgShown;
  }
  
  getMaxMsgSlug() {
    return this.mcqRenderer.getMaxMsgSlug();
  }

  getClickToDismissMsg() {
    return this.mcqRenderer.getClickToDismissMsg();
  }

  turnMaxMsgOff() {
    this.mcqRenderer.turnMaxMsgOff();
  }

  updateState(){

    // console.log('updateState mcq -----')
    this.mcqRenderer.updateState();
  }

}
